
    <div class="mm-content modal-content">
        <div class="modal-header {{PackageDetails?.header || 'jeemainheader'}}">
            <h4 class="modal-title"><strong>Syllabus</strong></h4>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="Close()">
                <span aria-hidden="true" class="close-font">&times;</span>
            </button>
        </div>
        <div class="modal-body">
            <div class="ilite-grade10-studying">
                <h4>{{PackageDetails?.name}}</h4>
                <h6>Exam Date: {{PackageDetails?.date}}</h6>
                <h5>Grade {{PackageDetails?.grade}}</h5>
                <div *ngFor="let sub of PackageDetails?.subjects" class="popup-flex">
                    <div>
                        <figure>
                            <img src="assets/img/subject-icons/{{imgs[sub.toLowerCase()]}}.png" alt="">
                        </figure>
                    </div>
                    <div class="popup-content">
                        <h6>{{sub}}</h6>
                        <small>{{PackageDetails?.syllabus}}</small>
                    </div>
                </div>
            </div>
        </div>
    </div>
